<template>
  <Modal id="UploadRecordDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('uploadRecord.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('uploadRecord.field.id_upl_rec')">{{data.idUplRec}}</DescriptionsItem>
      <DescriptionsItem :label="$t('uploadRecord.field.type')">{{selectList.typeList.find(item=>item.value===data.type).label}}</DescriptionsItem>
      <DescriptionsItem :label="$t('uploadRecord.field.created_time')">{{data.createdTime}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "UploadRecordDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
        typeList: [{value: 1,label: 'Mpf'},{value:2,label: 'GI'}],
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>